<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-15 07:06:07
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-11-02 10:06:18
 * @FilePath: /bpm-form/src/components/wgForm/item-items/wg-radio.vue
 * @Description: 描述
 -->
<template>
  <div widget-type="radio">
    <a-radio-group v-model="text"
      :size="size"
      :data-model="fieldName"
      :disabled="disabled"
      :class="options.customClass"
      @change="handleChange">
      <a-radio v-for="(item, index) in filterRadioList"
        :disabled="item.disabled || false"
        :value="item.value"
        :key="index">{{item.label || item.value}}</a-radio>
    </a-radio-group>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        inline: true,
        defaultValue: '',
        showLabel: false,
        options: [],
        required: true,
        width: '100%',
        remote: false,
        remoteType: 'func',
        remoteOption: '',
        remoteOptions: [],
        props: {
          value: 'value',
          label: 'label',
        },
        remoteFunc: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        disabled: false,
      },
      radioList: [],
    };
  },
  mounted() {
    this.initOptions();
  },
  computed: {
    filterRadioList() {
      return this.radioList.filter((item) => {
        if (item.deleteFlag === '2' && item.value === this.text) {
          item.disabled = true;
          return true;
        }
        return item.deleteFlag !== '2';
      });
    },
  },
  methods: {
    handleChange(e) {
      const { rowIndex, fieldName: field } = this;
      const newVal = e.target.value || this.defaultValue;
      if (!this.isNested) {
        const value = {
          type: 'radio',
          rowIndex,
          field,
          value: newVal,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal);
    },
    initOptions(otherArgs = {}) {
      const {
        remote, remoteType, remoteOption, remoteFunc, remoteOptions, props,
      } = this.options;
      const { func, args } = this.separateFunc(remoteFunc);
      if (remote && remoteType === 'func') {
        if (this.remote[func]) {
          this.remote[func](
            (data) => {
              this.radioList = data.map(item => ({
                value: item[props.value],
                label: item[props.label],
                deleteFlag: item.deleteFlag,
                disabled: item.disabled || false,
                children: item[props.children],
              }));
            },
            { args, otherArgs },
          );
        } else {
          this.radioList = remoteOptions;
        }
      } else if (remote && remoteType === 'option') {
        if (this.dynamic[remoteOption]) {
          this.radioList = this.dynamic[remoteOption];
        } else {
          this.radioList = remoteOptions;
        }
      } else {
        this.radioList = this.options.options;
      }
      // remoteType
    },
  },
};
</script>
